import { NewFeatureConfig, newFeatures } from './config/newFeatures'

// Maps for efficient lookups
const uiTargetToFeaturesMap = new Map<string, NewFeatureConfig[]>()
const dismissalTargetToFeatureMap = new Map<string, NewFeatureConfig>()

function initializeMaps() {
  if (uiTargetToFeaturesMap.size > 0) return // Already initialized

  Object.entries(newFeatures).forEach(([, feature]) => {
    const typedFeature = feature as NewFeatureConfig
    typedFeature.uiTargets.forEach((target: string) => {
      if (!uiTargetToFeaturesMap.has(target)) {
        uiTargetToFeaturesMap.set(target, [])
      }
      uiTargetToFeaturesMap.get(target)?.push(typedFeature)
    })

    if (typedFeature.dismissesOnVisit) {
      dismissalTargetToFeatureMap.set(
        typedFeature.dismissesOnVisit,
        typedFeature,
      )
    }
  })
}

export const getFeaturesForUITarget = (
  targetKey: string,
): NewFeatureConfig[] => {
  initializeMaps()
  return uiTargetToFeaturesMap.get(targetKey) || []
}

export const getFeatureForDismissalTarget = (
  targetKey: string,
): NewFeatureConfig | null => {
  initializeMaps()
  return dismissalTargetToFeatureMap.get(targetKey) || null
}
